import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';
import { useScopeKey } from './useScopeKey.js';

export function useCategories(period) {
  const scopeKey = useScopeKey();
  const qs =
    period?.from && period?.to
      ? `?from=${period.from}&to=${period.to}`
      : '';
  return useQuery({
    queryKey: ['categories', scopeKey, period?.from, period?.to],
    queryFn: () => api.get(`/categories${qs}`),
    staleTime: 30_000,
    enabled: scopeKey !== 'loading',
  });
}

export function useCreateCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => api.post('/categories', body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['categories'] });
      qc.invalidateQueries({ queryKey: ['mapping-rules'] });
    },
  });
}

export function useUpdateCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }) => api.patch(`/categories/${id}`, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['categories'] });
    },
  });
}

export function useDeleteCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => api.delete(`/categories/${id}`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['categories'] });
      qc.invalidateQueries({ queryKey: ['mapping-rules'] });
      qc.invalidateQueries({ queryKey: ['transactions'] });
    },
  });
}
